import { get, post, patch, remove } from '../utils/api';

export const lessonAdd = (payload) => post('lesson', payload);

export const getLessonById = (payload) => get(`lesson/${payload}`);

export const patchLessonById = (payload) => patch(`lesson/${payload.id}`, payload);

export const getLessonsForGroup = (payload) => get(`lessons/${payload}`);

export const removeLessonById = (payload) => remove(`lesson/${payload}`);
